import fetch from 'utils/fetch';

//export function getLogin(obj){
//	return fetch({
//		url:'/brand/authinvite?token='+obj.utoken+'&invite_id='+obj.invite_id,
//		method:'get',
//	})
//}

//export function postMsg(data){
//	return fetch({
//		url:'/msg/send',
//		method:'post',
//		data:data
//	})
//}
//
//export function postLogin(data){
//	return fetch({
//		url:'/UserYh/login',
//		method:'post',
//		data:data
//	})
//}


export function postAuthLogin(data){
	return fetch({
		url:'/index/login/login',
		method:'post',
		data:data
	})
}

export function postAgentConfig(data){
	return fetch({
		url:'/index/company/agent_config',
		method:'post',
		data:data
	})
}




// WEBPACK FOOTER //
// ./src/api/login.js